<template>
	<div class="product-tile-skeleton">
		<div class="skeleton-top">
			<div class="skeleton-badge"></div>
			<div class="skeleton-colors"></div>
		</div>
		<div class="skeleton-image"></div>
		<div class="skeleton-info">
			<div class="skeleton-line short"></div>
			<div class="skeleton-line medium"></div>
			<div class="skeleton-line long"></div>
		</div>
	</div>
</template>

<script>
import SkeletonTile from "./SkeletonTile.ts";
export default {
	...SkeletonTile,
};
</script>
<style lang="scss">
@import "./SkeletonTile.scss";
</style>
